<template>
  <CardMenu @confirm="onConfirm">
    <PopoverMenuSection>
      <PopoverMenuItem
        shortcut="confirm"
        :primary-text="$t('action.open')"
        :to="{ name: 'project', params: { projectId: project.id } }"
        data-test-id="project-card-menu-open"
      >
        <template #info-icon><OpenIcon16 /></template>
      </PopoverMenuItem>
    </PopoverMenuSection>

    <PopoverMenuSection divider>
      <PopoverMenuItem
        :primary-text="$t('menu.projectSettings')"
        :to="{ name: 'projectsettings', params: { projectId: project.id } }"
        data-test-id="project-card-menu-settings"
      >
        <template #info-icon><SettingsIcon16 /></template>
      </PopoverMenuItem>
      <template v-if="project.owner.id === user.id">
        <PopoverMenuItem
          :primary-text="$t('action.invite')"
          @click="$emit('show-invite-menu')"
          data-test-id="project-card-menu-add-invitation"
        >
          <template #info-icon><AddUserIcon16 /></template>
        </PopoverMenuItem>
      </template>
    </PopoverMenuSection>
    <template v-if="project.owner.id === user.id">
      <PopoverMenuSection divider>
        <PopoverMenuItem
          destructive
          :primary-text="$t('projectSettings.deleteProject')"
          @click="$emit('show-delete-menu')"
          data-test-id="project-card-menu-delete"
        >
          <template #info-icon><DeleteIcon16 /></template>
        </PopoverMenuItem>
      </PopoverMenuSection>
    </template>
  </CardMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import OpenIcon16 from '@/components/Icons/OpenIcon16.vue';
import SettingsIcon16 from '@/components/Icons/SettingsIcon16.vue';
import AddUserIcon16 from '@/components/Icons/AddUserIcon16.vue';
import DeleteIcon16 from '@/components/Icons/DeleteIcon16.vue';
import CardMenu from '@components/Card/CardMenu.vue';

export default defineComponent({
  name: 'ProjectCardMenu',

  components: {
    CardMenu,
    OpenIcon16,
    SettingsIcon16,
    AddUserIcon16,
    DeleteIcon16,
  },

  props: {
    project: {
      type: Object,
      required: true,
    },

    user: {
      type: Object,
      required: true,
    },
  },

  emits: { 'show-invite-menu': null, 'show-delete-menu': null },

  methods: {
    onConfirm() {
      this.$router.push({ name: 'project', params: { projectId: this.project.id } });
    },
  },
});
</script>
